type newProductsType = {
  floor: number,
  products: {
    imgSrc: string,
    name: string,
    genre: string,
    url: string,
    isNew: boolean,
    isModal: boolean,
  }[]
}

const newProducts: newProductsType[] = [
  {
    floor: 1,
    products: [
      {
        imgSrc: '/asset/floor/floor1_area16_slide1_modal0.png',
        name: 'SOLANA',
        genre: 'ワークステーション',
        url: '/digital/fair2021/showroom/floor4/area17.html?slide=1&modal=0',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area16_slide1_modal1.png',
        name: 'FABRE',
        genre: 'オフィスチェアー',
        url: '/digital/fair2021/showroom/floor4/area17.html?slide=1&modal=1',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area16_slide2_modal0.png',
        name: 'Region',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area17.html?slide=2&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area16_slide2_modal1.png',
        name: 'FOCUS PANEL',
        genre: 'デスク周辺用品',
        url: '/digital/fair2021/showroom/floor4/area17.html?slide=2&modal=1',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area16_slide0_modal0.png',
        name: 'UPTIS',
        genre: 'ワークステーション',
        url: '/digital/fair2021/showroom/floor4/area17.html?slide=0&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area16_slide0_modal1.png',
        name: 'ing',
        genre: 'オフィスチェアー',
        url: '/digital/fair2021/showroom/floor4/area17.html?slide=0&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area16_slide0_modal2.png',
        name: 'FreeWagon',
        genre: 'デスク周辺用品',
        url: '/digital/fair2021/showroom/floor4/area17.html?slide=0&modal=2',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide4_modal1.png',
        name: 'Region Adjustable Counter',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=4&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide4_modal0.png',
        name: 'COODE',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=4&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide5_modal0.png',
        name: 'WORK POD',
        genre: '間仕切り',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=5&modal=0',
        isNew: true,
        isModal: true,
      // },{
      //   imgSrc: '/asset/floor/floor1_area15_slide4_modal1.png',
      //   name: 'TINY CUBE',
      //   genre: '0',
      //   url: '/digital/fair2021/showroom/floor4/area16.html?slide=5&modal=1',
      //   isNew: true,
      //   isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide3_modal0.png',
        name: 'SEQUENCE Tilt',
        genre: 'ワークステーション',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=3&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide3_modal1.png',
        name: 'SEQUENCE',
        genre: 'ワークステーション',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=3&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide2_modal0.png',
        name: 'SENTIR',
        genre: 'ワークステーション',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=2&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide2_modal1.png',
        name: 'JUKE',
        genre: '収納システム',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=2&modal=1',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide1_modal0.png',
        name: 'Notion',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=1&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide1_modal1.png',
        name: 'interval',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=1&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide0_modal0.png',
        name: 'dop',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=0&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide1_modal0.png',
        name: 'inframe',
        genre: 'コラボレーション用家具',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=1&modal=0',
        isNew: true,
        isModal: true,
      // },{
      //   imgSrc: '/asset/floor/floor1_area18_slide0_modal1.png',
      //   name: 'JUKE',
      //   genre: 'オフィスラウンジ',
      //   url: '/digital/fair2021/showroom/floor4/area19.html?slide=0&modal=1',
      //   isNew: false,
      //   isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area19_slide0_modal0.png',
        name: 'AIRTRIEVE',
        genre: '会議用テーブル',
        url: '/digital/fair2021/showroom/floor4/area20.html?slide=0&modal=0',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area19_slide0_modal1.png',
        name: 'Duora',
        genre: 'オフィスチェアー',
        url: '/digital/fair2021/showroom/floor4/area20.html?slide=0&modal=1',
        isNew: true,
        isModal: true,
      // },{
      //   imgSrc: '/asset/floor/floor1_area13_slide2_modal1.png',
      //   name: 'collesso',
      //   genre: 'オフィスラウンジ',
      //   url: '/digital/fair2021/showroom/floor4/area14.html?slide=2&modal=1',
      //   isNew: false,
      //   isModal: true,
      // },{
      //   imgSrc: '/asset/floor/floor1_area14_slide3_modal0.png',
      //   name: 'Region',
      //   genre: 'オフィスラウンジ',
      //   url: '/digital/fair2021/showroom/floor4/area15.html?slide=3&modal=0',
      //   isNew: false,
      //   isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area14_slide1_modal0.png',
        name: 'Franka',
        genre: 'コラボレーション用家具',
        url: '/digital/fair2021/showroom/floor4/area15.html?slide=1&modal=0',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area14_slide1_modal1.png',
        name: 'Patio',
        genre: 'コラボレーション用家具',
        url: '/digital/fair2021/showroom/floor4/area15.html?slide=1&modal=1',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area14_slide1_modal2.png',
        name: 'WELCA',
        genre: 'コラボレーション用家具',
        url: '/digital/fair2021/showroom/floor4/area15.html?slide=1&modal=2',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area14_slide0_modal0.png',
        name: 'inGREEN',
        genre: 'オフィスラウンジ',
        // url: '0',
        url: '/digital/fair2021/showroom/floor4/area15.html',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area15_slide0_modal1.png',
        name: 'inframe',
        genre: 'コラボレーション用家具',
        url: '/digital/fair2021/showroom/floor4/area16.html?slide=0&modal=1',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide2_modal0.png',
        name: 'AllinOne',
        genre: '会議用イス',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=2&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide2_modal1.png',
        name: 'Collesso',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=2&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide0_modal0.png',
        name: 'CHESS',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=0&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide0_modal1.png',
        name: 'CORNE',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=0&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide0_modal2.png',
        name: 'materibo',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=0&modal=2',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide0_modal3.png',
        name: 'エナジーカート（エナジーシリーズ）',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=0&modal=3',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide0_modal4.png',
        name: 'INITIA',
        genre: 'コラボレーション用家具',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=0&modal=4',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area13_slide0_modal5.png',
        name: 'STACKA',
        genre: 'リフレッシュ用家具',
        url: '/digital/fair2021/showroom/floor4/area14.html?slide=0&modal=5',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area17_slide0_modal1.png',
        name: 'METTI',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area18.html?slide=0&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area17_slide0_modal0.png',
        name: 'SETTLE',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area18.html?slide=0&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area10_slide0_modal0.png',
        name: 'STRATA',
        genre: 'デスクシステム',
        url: '/digital/fair2021/showroom/floor4/area11.html?slide=0&modal=0',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area10_slide0_modal1.png',
        name: 'iSデスク',
        genre: 'デスクシステム',
        url: '/digital/fair2021/showroom/floor4/area11.html?slide=0&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area10_slide0_modal2.png',
        name: 'EDIA',
        genre: '収納システム',
        url: '/digital/fair2021/showroom/floor4/area11.html?slide=0&modal=2',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area8_slide0_modal0.png',
        name: 'brackets',
        genre: 'コラボレーション用家具',
        url: '/digital/fair2021/showroom/floor4/area09.html?slide=0&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area7_slide0_modal2.png',
        name: 'DAYS OFFICE',
        genre: 'オフィスラウンジ',
        url: '/digital/fair2021/showroom/floor4/area08.html',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area7_slide0_modal0.png',
        name: 'hang like',
        genre: 'DAYS OFFICE',
        url: '/digital/fair2021/showroom/floor4/area08.html?slide=0&modal=0',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area7_slide0_modal1.png',
        name: 'offset frame',
        genre: 'DAYS OFFICE',
        url: '/digital/fair2021/showroom/floor4/area08.html?slide=0&modal=1',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area1_slide0_modal1.png',
        name: 'Mycket',
        genre: 'リフレッシュ用家具',
        url: '/digital/fair2021/showroom/floor4/area02.html?slide=0&modal=1',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area1_slide0_modal0.png',
        name: 'Plocka',
        genre: 'リフレッシュ用家具',
        url: '/digital/fair2021/showroom/floor4/area02.html?slide=0&modal=0',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area2_slide0_modal0.png',
        name: 'KATE',
        genre: 'リフレッシュ用家具',
        url: '/digital/fair2021/showroom/floor4/area03.html?slide=0&modal=0',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor1_area0_slide0_modal0.png',
        name: 'any',
        genre: '会議用イス',
        url: '/digital/fair2021/showroom/floor4/area01.html?slide=0&modal=0',
        isNew: true,
        isModal: true,
      }
    ]
  },{
    floor: 0,
    products: [
      {
        imgSrc: '/asset/floor/floor0_area0_slide0_modal0.png',
        name: 'normann copenhagen',
        genre: 'Brand Collection',
        // url: 'https://www.kokuyo-furniture.co.jp/products/office/brandcollection/',
        url: '/digital/fair2021/showroom/floor3/area01.html',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area1_slide0_modal0.png',
        name: 'MATTIAZZI',
        genre: 'Brand Collection',
        // url: 'https://www.kokuyo-furniture.co.jp/products/office/brandcollection/mattiazzi/',
        url: '/digital/fair2021/showroom/floor3/area02.html',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area2_slide0_modal0.png',
        name: 'PEDRALI',
        genre: 'Brand Collection',
        // url: 'https://www.kokuyo-furniture.co.jp/products/office/brandcollection/pedrali/',
        url: '/digital/fair2021/showroom/floor3/area03.html',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area3_slide0_modal0.png',
        name: 'MAGIS',
        genre: 'Brand Collection',
        // url: 'https://www.kokuyo-furniture.co.jp/products/office/brandcollection/magis/',
        url: '/digital/fair2021/showroom/floor3/area04.html',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area4_slide0_modal0.png',
        name: 'STELLAR WORKS',
        genre: 'Brand Collection',
        // url: 'https://www.kokuyo-furniture.co.jp/products/office/brandcollection/',
        url: '/digital/fair2021/showroom/floor3/area05.html',
        isNew: true,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area5_slide0_modal0.png',
        name: 'Wilkhahn',
        genre: 'Brand Collection',
        // url: 'https://www.wilkhahn.co.jp/products/',
        url: '/digital/fair2021/showroom/floor3/area06.html',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area6_slide0_modal0.png',
        name: 'SENTIR',
        genre: 'ワークステーション',
        // url: 'https://kokuyo.jp/sentir/',
        url: '/digital/fair2021/showroom/floor3/area07.html',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area8_slide0_modal0.png',
        name: 'SEQUENCE',
        genre: 'ワークステーション',
        // url: 'https://kokuyo.jp/sequence/',
        url: '/digital/fair2021/showroom/floor3/area09.html',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area7_slide0_modal0.png',
        name: 'SAIBI',
        genre: 'ワークステーション',
        // url: 'https://kokuyo.jp/saibi/',
        url: '/digital/fair2021/showroom/floor3/area08.html',
        isNew: false,
        isModal: true,
      },{
        imgSrc: '/asset/floor/floor0_area7_slide0_modal1.png',
        name: 'SAIBI-TX',
        genre: 'ワークステーション',
        // url: 'https://kokuyo.jp/saibi/',
        url: '/digital/fair2021/showroom/floor3/area08.html',
        isNew: false,
        isModal: true,
      }
    ]
  }
];

export default newProducts;
